// AppLayout — sidebar shell tối giản: chỉ "Trang chủ".
// "Quản trị hệ thống" chuyển vào dropdown user menu (header).

import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { VMTLayout } from '@vmt/shared';

const ROUTE_TO_KEY = {
  '/': 'home',
};

export function AppLayout() {
  const { t } = useTranslation();
  const location = useLocation();
  const selectedKey = ROUTE_TO_KEY[location.pathname] ?? 'home';

  const sidebarItems = useMemo(() => [
    { key: 'home', icon: <HomeOutlined />, label: <Link to="/">{t('menu.home')}</Link> },
  ], [t]);

  const headerTitle = t('menu.home');

  return (
    <VMTLayout
      sidebarItems={sidebarItems}
      selectedKey={selectedKey}
      headerTitle={headerTitle}
      moduleName={headerTitle}
      currentModuleKey="home"
    />
  );
}
